import axios, { AxiosResponse } from 'axios'

let URL = 'https://refactorgpt-api.onrender.com'
if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development') {
  URL = 'https://refactorgpt-api.onrender.com'
}

export const refactor = async (value: string): Promise<string> => {
  const options = {
    method: 'POST',
    url: `${URL}/change_input_v2`,
    headers: { 'Content-Type': 'application/json' },
    data: {
      input: value,
    },
  }

  try {
    const res: AxiosResponse<any> = await axios.request(options)
    return res.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
